import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { fetchInitialData,fetchInitialData2,fetchInitialData5 } from "../fetchData";
import Right from '../right/Right';
import withLocation from "../../withLocation";
import Service from '../service/Service';
import './Expert.css';
import AnswerOverlay from "./common/AnswerOverlay";


const service = new Service();

class ExpertDetail extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        let serverSideData = {};    
        let expertData = {};
        let expertActionData = {};
        let profileMemories = [];
        let expertQuestionData= [];
        let userActionData=[];
        let myAnswer=[];
        let answerLike=[];
        let authData = '';
        let firstname='';
        let userPhoto='';
        let userId='';
        let follow_my_user=[];
        let follow_que=[];
        this.answerRef = React.createRef();

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            console.log('-----------serverSideData---',serverSideData);
            expertData = serverSideData?.data2?.expertData || {};
            expertActionData = serverSideData?.data1?.ActionDataCount[0] || {};
            if(Array.isArray(serverSideData?.data3?.result)){
                profileMemories =  serverSideData?.data3?.result || [];
            }else{
                profileMemories = [];
            }
            
            expertQuestionData =  serverSideData?.data4?.QuestionData || [];

            if (Array.isArray(serverSideData?.data5?.ActionData)) {
                userActionData = serverSideData.data5.ActionData[0] || {};
                myAnswer = userActionData?.my_answer;
                answerLike = userActionData?.like
                follow_my_user = userActionData?.follow_my_user
                follow_que = userActionData?.follow
            } else {
                userActionData = {};
                myAnswer=[];
                answerLike= [];
            }

            authData = window.__initialData__["authData"];

            // firstname = authData?.childData?.UserMaster?.firstname || "";
            // userId = authData?.childData?.UserMaster?.UserID;
            // userPhoto = authData?.childData?.UserMaster?.userPhoto;

            firstname = global?.userAry?.childData?.UserMaster?.firstname || "";
            userId = global?.userAry?.childData?.UserMaster?.UserID;
            userPhoto = global?.userAry?.childData?.UserMaster?.userPhoto;

            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }

        this.state = {
            expert: expertData,  
            pageTitle: serverSideData?.data1?.expPageTitle || "",
            pageDescription: serverSideData?.data1?.expPageDes || "",
            error: null,
            isAboutExpanded: false,
            isAssociateExpanded: false,
            expertActionData: expertActionData,
            profileMemories: profileMemories,
            expertQuestionData: expertQuestionData,
            userActionData:userActionData,
            myAnswer: myAnswer,
            answerLike: answerLike,
            auth_Data: global?.userAry || authData,
            firstname: firstname,
            userPhoto: userPhoto,
            userId:userId,
            follow_my_user:follow_my_user || [],
            answerError:'',
            follow_que: follow_que,
            pageno:1,
            isDesktop: null,
            showFollowers: false,
            followersData: [],
            isLoadingMore: false,
            hasMore: true,
            expandedAnswers:{}
        };
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        console.log("Initial Action called with URL:", reqUrl);

        // const urlParts = reqUrl.split('/');
        // const userId = urlParts[urlParts.length - 1];
        const cleanUrl = reqUrl.split('?')[0];
        const urlParts = cleanUrl.split('/').filter(Boolean);
        const userId = urlParts[urlParts.length - 1];

        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        
        let obj1 = {
            url: global.api_url + "getUserActionsCount",
            body: JSON.stringify({
                "user_id": userId
            })
        };

        let obj2 = {
            url: global.api_url + "getexpertdata",
            body: JSON.stringify({
                "expertId": userId
            })
        };

        let obj3 = {
            url: global.api_url + "getprofilememories",
            body: JSON.stringify({
                "creatorId": userId,
                "pageSize": 8,
                "pageNo": 1
            })
        };

        let obj4 = {
            url: global.api_url + "getMyAnswerData",
            body: JSON.stringify({
                "creater_id": userId,
                "pagesize": 14,
                "pageno": 1
            })
        };

        let obj5 = {
            url: global.api_url + "getUserActions",
            body: service.getUserActionPayload(childData, authData['mycid'])
        };

        return fetchInitialData5(obj1, obj2, obj3, obj4, obj5, JSON.stringify(header));
    }


    componentDidMount() {
        console.log("Component did mount called in ExpertDetail with state:", this.state.expert);
        document.addEventListener("click", this.domclick);

        this.updateDeviceType(); // calculate first time
        window.addEventListener('resize', this.updateDeviceType);

        // console.log('----------expertQuestionData',this.state.expertQuestionData);
        // console.log('----------expertQuestionData',this.state.expertQuestionData.length);
        // console.log('-----------this.state.expertActionData.my_answer_count', this.state.expertActionData.my_answer_count);
        console.log('------------expandedAnswers', this.state.expandedAnswers);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDeviceType);
    }

    updateDeviceType = () => {
        const isDesktop = window.innerWidth >= 768;
        if (this.state.isDesktop !== isDesktop) {
            this.setState({ isDesktop });
        }
    }

    handleScroll=()=>{
        if (!this.listRef || this.state.isLoadingMore || !this.state.hasMore) return;
        const { scrollTop, scrollHeight, clientHeight } = this.listRef;

        if (scrollHeight - scrollTop <= clientHeight + 50) {
            this.loadMoreFollowers();
        }
    }


    domclick=(e)=>{
        if(e.target.classList.contains('addAns-overlay')){
            document.getElementsByClassName('addAns-overlay')[0].style.display = 'none';
            document.getElementsByTagName('body')[0].style.overflow = 'visible';
            document.getElementById('post_answer_text').value = '';
            document.getElementById('answer_queId').value = '';
            document.getElementById('quation_title').value = '';
            document.getElementById('answer_queUserId').value = '';s
        }
    }

    toggleAboutReadMore = () => {
        this.setState(prev => ({
            isAboutExpanded: !prev.isAboutExpanded
        }));
    };

    toggleAssociateReadMore = () => {
        this.setState(prev => ({
            isAssociateExpanded: !prev.isAssociateExpanded
        }));
    };

    generateSlug = (title) => {
        if (!title) return "";

        return title
            .replace(/#\w+/g, "")        // remove hashtags
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]/g, "-")  // replace special characters
            .replace(/-+/g, "-")         // remove duplicate hyphens
            .replace(/^-|-$/g, "")       // remove starting/ending hyphen
            .substring(0, 100);          // limit to 100 chars
    };

    postAns = (qId, qUserId, quationTitle) => {

        console.log('----1', qId);
        console.log('----2',qUserId);

        if (global.ftk !== '') {

            document.getElementById('answer_queId').value = qId;
            document.getElementById('answer_queUserId').value = qUserId;
            document.getElementById('quation_title').value = quationTitle;

            document.getElementsByClassName('addAns-overlay')[0].style.display = 'block';
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';

        } else {

            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;

        }
    }

    goToMyanswer=()=>{
        
        if (this.answerRef.current) {
            this.answerRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }

    goToMemories =(count)=>{
        const pathname = this.props.location.pathname;
        const parts = pathname.split("/");
        const lastSegment = parts[parts.length - 1];
        const url = `/experts/memories/${lastSegment}`;
        window.location.href = service.getRedirectUrl(url);
    }

    openFollowersList = (expertId, followCount)=>{
        service.showLoader();
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';

        let payload = {
            "creater_id": expertId,
            "pagesize":100,
            "pageno":1
        }

        let url = global.api_ci_url + "api/fetchfromCI/getuserfollowersinfo"; 

        service.postServiceCall(url, payload)
        .then((json) => {
            if (json?.msg === "1" && json?.followersUserInfo?.length > 0) {
                this.setState({ showFollowers: true });
                this.setState({
                    followersData: json.followersUserInfo,   // ✅ FIX HERE
                    showFollowers: true,
                    pageno:1,
                    hasMore: json?.followersUserInfo?.length > 0
                });
            }
            service.hideLoader();

            setTimeout(() => {
                document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            }, 500);
            
        })
        .catch((error) => {
            console.error("Error toggling like:", error);
            service.hideLoader();
        });
        
    }

    loadMoreFollowers = () => {

        if (this.state.isLoadingMore || !this.state.hasMore) return;

        const nextPage = this.state.pageno + 1;

        this.setState({ isLoadingMore: true });

        let payload = {
            creater_id: this.state.expert?.user_id,
            pagesize: 100,
            pageno: nextPage
        };

        let url = global.api_ci_url + "api/fetchfromCI/getuserfollowersinfo";

        service.postServiceCall(url, payload)
        .then((json) => {

            if (json?.msg === "1") {

                const newData = json.followersUserInfo || [];

                this.setState((prevState) => ({
                    followersData: [...prevState.followersData, ...newData], // ✅ append
                    pageno: nextPage,
                    isLoadingMore: false,
                    hasMore: newData.length > 0
                }));

            } else {
                this.setState({ isLoadingMore: false, hasMore: false });
            }
        })
        .catch(() => {
            this.setState({ isLoadingMore: false });
        });
    };  

    closePopup = (e)=>{
        this.setState({ 
            showFollowers: false,
            pageno: 1 
        });
        document.getElementsByTagName('body')[0].style.overflow = 'visible';
    }
 
    handleLike = (ansId, queId)=>{

        if(!global.ftk){
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }else{

            var userInfo = this.state.auth_Data.childData?.UserChildList;
            var userGender = this.state.auth_Data.childData?.UserMaster?.Sex;

            let childinfoArr = [];
            if (Array.isArray(userInfo)) {
                childinfoArr = userInfo.map(child => ({
                    ChildId: child.ChildId || child.childId,
                    ChildName: child.ChildName || child.childName,
                    DOB: child.DOB || child.dob,
                    Gender: child.Gender || child.gender ||"",
                    IsExpected: child.IsExpected||"",
                    Weight:child.Weight,
                    Height:child.Height,
                    ChildSeq:child.ChildSeq,
                    Relationship:child.Relationship,
                    childPhoto: child.childPhoto || child.childPhoto,
                    Age:child.Age,
                }));
            } 

            let payload={
                "action_status":1,
                "action_type":"like",
                "answer_id": ansId,
                "question_id":queId,
                "userPic":this.state.userPhoto,
                "userName":this.state.firstname,
                "childArr":childinfoArr,
                "userGender":userGender,
            }

            let url = global.api_ci_url + "api/fetchfromCI/saveAnsAction"; 

            // getuserlikeanswers
            service.postServiceCall(url, payload)
            .then((json) => {
                this.setState((prevState) => {

                    const updatedLikes = [...(prevState.answerLike || []), ansId];

                    const updatedQuestions = prevState.expertQuestionData.map(q => {
                        if (q.question_id === queId) {
                            return {
                                ...q,
                                answers: q.answers.map(ans => {
                                    if (ans.answer_id === ansId) {
                                        return {
                                            ...ans,
                                            ans_like_count: (ans.ans_like_count || 0) + 1
                                        };
                                    }
                                    return ans;
                                })
                            };
                        }
                        return q;
                    });

                    return {
                        answerLike: updatedLikes,
                        expertQuestionData: updatedQuestions
                    };
                });
                
            })
            .catch((error) => {
                console.error("Error toggling like:", error);
                service.hideLoader();
            });


            // getuserlikeanswers

        }

    }

    handleExpertFollow = (user_id,e,status) =>{

        var userInfo = this.state.auth_Data.childData;

        let childinfoArr = [];
        if (Array.isArray(userInfo)) {
            childinfoArr = userInfo.map(child => ({
                childId: child.ChildId || child.childId,
                childName: child.ChildName || child.childName,
                dob: child.DOB || child.dob,
                gender: child.Gender || child.gender ||"",
                childPic: child.childPhoto || child.childPhoto
            }));
        } else if (userInfo) {
            childinfoArr = [{
                childId: userInfo.ChildId || userInfo.childId,
                childName: userInfo.ChildName || userInfo.childName,
                dob: userInfo.DOB || userInfo.dob,
                gender: userInfo.Gender || userInfo.gender||"",
                childPic: userInfo.childPhoto || userInfo.childPhoto
            }];
        }

        let gender = '0'
        if(this.state.auth_Data?.gender == "Boy"){
            gender = '0';
        } else if(this.state.auth_Data?.gender == "Girl"){
            gender = '1';
        } else if(this.state.auth_Data?.gender == "Guardian"){
            gender = '2';
        }

        let payload ={
            user_id: user_id,
            userName: this.state.firstname,
            childArr: userInfo,
            userGender: gender,
            userPic: this.state.userPhoto,
            action_type: "follow_user",
            action_status: status
        }

        const url = global.api_ci_url + "api/fetchfromCI/saveUserFollowAction"; 

        service.postServiceCall(url, payload)
        .then((json) => {
            if (json?.success == "1") {
                this.setState((prevState) => {
                    let updatedFollow = Array.isArray(prevState.follow_my_user)
                        ? [...prevState.follow_my_user]
                        : [];

                    const expertId = user_id;
                    if (status == "1") {
                        // Follow
                        if (!updatedFollow.includes(expertId)) {
                            updatedFollow.push(expertId);
                        }
                    } else {
                        // Unfollow
                        updatedFollow = updatedFollow.filter(
                            id => id !== expertId
                        );
                    }
                    return { follow_my_user: updatedFollow };
                });

            }
            
        })
        .catch((error) => {
            console.error("Error toggling like:", error);
            service.hideLoader();
        });

    }

    handleFollow =(status,qId,qTitle,creId)=>{

        var userGender = this.state.auth_Data.childData?.UserMaster?.Sex;
        let userchildList = this?.state?.auth_Data?.childData?.UserChildList;

        let expecting_dob = '';

        if(this.state.auth_Data.childData?.UserChildList[0].IsExpected == 1) {
            expecting_dob = this.state.auth_Data?.childData?.UserChildList[0].DOB;
        }else{
            expecting_dob = '';
        }

        let payload ={
            "childinfo":userchildList,
            "question_type": 1,
            "action_status":status,
            "action_type":"follow",
            "creater_id":creId,
            "question_id":qId,
            "user_type":userGender,
            "que_type":"child",
            "question_title":qTitle,
            "expecting_dob":expecting_dob
        }

        let url = global.api_ci_url + "api/fetchfromCI/saveQueActions";

        service.postServiceCall(url, payload)
        .then((res) => {
            console.log("API response:", res);
            this.setState((prevState) => {
                let updatedFollowQue;

                if (status == 1) {
                    // Add ID
                    updatedFollowQue = [...prevState.follow_que, qId];
                } else {
                    // Remove ID
                    updatedFollowQue = prevState.follow_que.filter(
                        (id) => id !== qId
                    );
                }

                const updatedQuestions = prevState.expertQuestionData.map((item) => {
                    if (item.question_id === qId) {
                        return {
                            ...item,
                            follow_count: status == 1
                                ? item.follow_count + 1
                                : item.follow_count - 1
                        };
                    }
                    return item;
                });

                return { 
                    follow_que: updatedFollowQue,
                    expertQuestionData: updatedQuestions 
                };
            });
        })
        .catch((err) => {
            console.error("API error:", err);

            eleRef.setState({ answerError: 'Something went wrong' });
        });
    }


    loadMoreQues = (expertId) => {
        this.setState((prevState) => {
            const nextPage = prevState.pageno + 1;

            let payload = {
                creater_id: expertId,
                pagesize: 14,
                pageno: nextPage
            };

            let url = global.api_ci_url + "api/fetchfromCI/getMyAnswerData";

            service.postServiceCall(url, payload)
                .then((res) => {
                    // console.log('----------response', res);
                    if(res.msg == 1){
                        this.setState((innerPrevState) => ({
                            expertQuestionData: [
                                ...innerPrevState.expertQuestionData,   
                                ...(res.QuestionData || [])       
                            ]
                        }));
                    }else{
                        console.log(res.QuestionData);
                    }
                })
                .catch((err) => {
                    console.error("API error:", err);
                    this.setState({ answerError: 'Something went wrong' });
                });

            return { pageno: nextPage };
        });
    };

    toggleAnswerReadMore = (answerId) => {
        console.log('----------------ansid',answerId);
        this.setState((prevState) => ({
            expandedAnswers: {
            ...prevState.expandedAnswers,
            [answerId]: !prevState.expandedAnswers[answerId]
            }
        }));


        console.log('--------------expandedAnswers', this.state.expandedAnswers);
    };

    render() {
        const hospitalImg = this.state.expert?.associated_hospital?.[0]?.hospital_bkimage;
        let expertPhoto = this.state.expert.profile_pic || "https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png"

        return (
            <main className="main-container">
               
                <Helmet>
                    <title>{(this.state.expert?.expname) || "Expert" } Expert at FirstCry Parenting </title>
                    <meta name="description" content="Browse our list of experts in various fields." />
                </Helmet>
                <div className="title expert_profile_title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/experts")} className="R11_9e">Expert Panel</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Expert Profile</span>
                    </div>
                    <h1 className="B24_00">Expert Profile</h1>
                </div>
               
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="my_account expert_panel_main expert_details">
                            <div className="menu_content expert-details-block">
                                <div className="user_profile_desk">
                                    <div className="expertprofile_desk">
                                        {hospitalImg && 
                                            <div className="hospital-image">
                                                <img src={hospitalImg} alt="hospital-banner" title="hospital-banner"/>
                                            </div>
                                        }
                                        {this.state.expert?.user_id &&
                                        <div className="expert_details_container">
                                            <div className="expert_photo">
                                                <img src={expertPhoto} alt={this.state.expert.expname || "Expert Profile"} 
                                                 onError={(e) => (e.target.src = "https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png")}
                                                />
                                            </div>
                                            <div className="expert_desc">
                                                <div className="expert_info">
                                                    <p className="B20_42">{ this.state.expert.expname}</p>
                                                </div>
                                                <div className="expert_qualification">
                                                    <span className="R14_42">
                                                        {this.state.expert.education_qualification} {this.state.expert.experience}
                                                    </span>
                                                </div>
                                                <div className="hospital_desc">
                                                    <div className="hospital-photo">
                                                        <img src={this.state.expert?.associated_hospital?.[0]?.hospital_image_url} alt=""  />
                                                    </div>
                                                    <div className="name_container">
                                                        <div className="hosp_nm R15_9e">
                                                            <p className="hospital_name">
                                                                {
                                                                    this.state.expert?.associated_hospital?.length
                                                                    ? `${this.state.expert.associated_hospital
                                                                        .map(h => h.hospital_name)
                                                                        .join(", ")}`
                                                                    : ""
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="social-container">
                                                    {this.state.expert?.social && this.state.expert?.social.length > 0 &&
                                                        this.state.expert?.social.map((social, index) => (
                                                        <span className="social-media" key={index}>
                                                            <a href={social.redirectionUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer nofollow"
                                                            >
                                                                <img src={social.imageIconUrl} alt="Facebook" />
                                                            </a>
                                                        </span>
                                                    ))}
                                                </span>

                                                {this.state.follow_my_user.includes(this.state.expert?.user_id) ? (
                                                    <span className="following_profile_btn M16_61"
                                                        onClick={(e) => this.handleExpertFollow(this.state.expert?.user_id, e, "0")
                                                        }
                                                    >
                                                        Following
                                                    </span>
                                                    ) : (
                                                    <span className="follow_profile_btn M16_61"
                                                        onClick={(e) =>
                                                        this.handleExpertFollow(this.state.expert?.user_id, e, "1")
                                                        }
                                                    >
                                                        Follow
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        }

                                        {/* expert associate starts */}
                                        <div className="expert_associate_container">
                                            <div className="associate_with">
                                                <span className="M16_42 associate_text">Associate With</span> 
                                                <span className="R14_61 more">
                                                    <span>
                                                        {/* associate_details */}
                                                        {this.state.expert.associate_details || ""}
                                                    </span>
                                                </span>
                                                {
                                                    this.state.expert?.associate_details?.length > 380 && (
                                                        <div className="read_more_link">
                                                            <a className="readmorelink R14_link" 
                                                                onClick={this.toggleAssociateReadMore}
                                                            >
                                                                Read More
                                                            </a>
                                                        </div>
                                                    )
                                                }                                            
                                            </div>
                                            <div className="about_expert">
                                                <span className="M16_42 expert_name">About {this.state.expert.expname || ""}</span>
                                                <span className={`R14_61 more ${this.state.isAboutExpanded ? "collapsed" : ""}`}>
                                                    <span className={`R14_61 more ${this.state.isAboutExpanded ? "showall" : ""}`}
                                                    >
                                                        {this.state.expert.about_dr || ""}
                                                    </span>
                                                </span>
                                                {
                                                    this.state.expert?.about_dr?.length > 380 && (
                                                    <div className="read_more_link">
                                                        <a className="readmorelink R14_link" 
                                                            onClick={this.toggleAboutReadMore}
                                                        >
                                                            {this.state.isAboutExpanded ? "Read Less" : "Read More"}
                                                        </a>
                                                    </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        {/* // expert associate endss */}

                                        {/* Stats Section */}
                                    </div>
                                    <div className="answer-like-follower-container">
                                        <ul className="left">
                                            <li className="left" onClick={this.goToMyanswer}>
                                                <span className={`${this.state.isDesktop?'B20_42':'B15_42'} `}>{this.state.expertActionData.my_answer_count || 0}</span>
                                                <span className="R14_42">Answers</span>
                                            </li>

                                            <li className="left">
                                                <span className={`${this.state.isDesktop?'B20_42':'B15_42'} `}>{this.state.expertActionData.myans_like_count || 0}</span>
                                                <span className="R14_42">Likes</span>
                                            </li>

                                            <li className="left 123"  
                                            onClick={() =>this.goToMemories(this.state.expertActionData.memory_count)} >
                                                <span className={`${this.state.isDesktop?'B20_42':'B15_42'} `}>{this.state.expertActionData.memory_count || 0}</span>
                                                <span className="R14_42">Memory</span>
                                            </li>

                                            <li className="left" onClick={()=>this.openFollowersList(this.state.expert?.user_id, this.state.expertActionData.follow_user_count)}>
                                                <span className={`${this.state.isDesktop?'B20_42':'B15_42'} `}>{this.state.expertActionData.follow_user_count || 0}</span>
                                                <span className="R14_42">Followers</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="viewslide_btns" onClick={() => { window.location.href = "/experts/"; }} >
                                    <span className="askB_1 view_btn" id="view_btn">
                                        <span className="B14_white">CHECK OUR PANEL OF EXPERTS</span>
                                    </span>
                                </div>
                                {/* Memory List Start */}
                                {this.state.profileMemories?.length > 0 &&
                                <div id="memories_list" className="memory-container">
                                    
                                    <div className="M18_42 memory-title-container">
                                    Memories Uploaded by {this.state.expert.expname}
                                    </div>
                                    
                                    <div className="memory-img-container">
                                        <ul>
                                            {this.state.profileMemories.map((memory, index) => {

                                                const isLast =
                                                index === this.state.profileMemories.length - 1;

                                                const remainingCount =
                                                (this.state.memoryCount || 0) -
                                                this.state.profileMemories.length;

                                                return (
                                                <li key={memory.memoryId}>

                                                    <a href={`/memories/photodetails/${memory.memoryId}`}>
                                                        <img src={memory.memoryImage} alt="memory" />
                                                    </a>

                                                    {(memory.likeCount > 0 || memory.commentCount > 0) && (
                                                    <>
                                                        <div className="memory-icons-bg"></div>

                                                        <div className="memory-icons M14_white">

                                                        {memory.likeCount > 0 && (
                                                            <span className="like-cnt">
                                                            <span className="icon" data-icon-font="T"></span>
                                                            <span>{memory.likeCount}</span>
                                                            </span>
                                                        )}

                                                        {memory.commentCount > 0 && (
                                                            <span className="comment-cnt">
                                                            <span className="icon" data-icon-font="e"></span>
                                                            <span>{memory.commentCount}</span>
                                                            </span>
                                                        )}

                                                        </div>
                                                    </>
                                                    )}

                                                    {isLast &&
                                                    this.state.showMemCnt &&
                                                    remainingCount > 0 && (
                                                        <>
                                                        <span className="more-mem-bg"></span>

                                                        <span
                                                            className="M14_white more-mem"
                                                            onClick={() =>
                                                            this.loadMoreMemory(this.state.memoryCount)
                                                            }
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            +{remainingCount} More
                                                        </span>
                                                        </>
                                                    )}

                                                </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                }
                                {/* Memory List End */}
                                {Array.isArray(this.state.expertQuestionData) &&
                                <div id="answer_list" ref={this.answerRef}>

                                    {Array.isArray(this.state.expertQuestionData) && this.state.expertQuestionData?.map((row) => {

                                        const slug = this.generateSlug(row.question_title);
                                        return(
                                            <div className="questions" id={row.queid_ency} key={row.queid_ency}>
                                                {/* Top Section */}
                                                <div className="R13_9e que_top">
                                                    <span className="mom">
                                                    {row.user_description || "Not Specified"}
                                                    </span>

                                                    <span className="rt">
                                                    {row.posted_time || "Not Specified"}
                                                    </span>
                                                </div>

                                                {/* Question Title */}
                                                <div className="que M17_42">
                                                    <a key={row.queid_ency} href={service.getRedirectUrl(`/qna/q/${slug}-${row.queid_ency}`)}>
                                                        <span className="QA_txt M17_9e">Q.</span>
                                                        <span className="M17_42">
                                                            {row.question_title}
                                                        </span>
                                                    </a>
                                                </div>

                                                {/* Question Bottom Section */}
                                                <div className="que_botm" style={row.answer_count === 0 ? { borderBottom: "none" } : {}} >

                                                    {/* Answer Button */}
                                                    <div className="R13_9e left post_ans"
                                                        onClick={() =>this.postAns(row.queid_ency,row.creater_id,row.question_title)}>
                                                        <span className="icon" data-icon-font="&#xe01d;"></span>
                                                        Answer
                                                    </div>

                                                    {/* Answer Count */}
                                                    <div className="ans_cnt_container R13_9e left">
                                                        <a key={row.queid_ency} href={service.getRedirectUrl(`/qna/q/${slug}-${row.queid_ency}`)}
                                                             rel="noopener noreferrer" className="answer-link" >
                                                            <span
                                                                className={`ans_icon icon ${
                                                                    Array.isArray(this.state.myAnswer) &&
                                                                    this.state.myAnswer.includes(row.queid_ency)
                                                                    ? "active-like"
                                                                    : ""
                                                                }`}
                                                                data-icon-font="&#xe004;" >
                                                            </span>
                                                            <span className="ans_cnt">{row.answer_count || 0}</span>
                                                        </a>
                                                    </div>

                                                    {/* Follow Section */}
                                                    <span className="rt R13_9e">

                                                    {this.state.follow_que.includes(row.queid_ency)? (
                                                        <span className="followqa follow left R13_9e dont-follow active-like" onClick={() => this.handleFollow("0", row.queid_ency, row.question_title, row.creater_id) } >
                                                        Followed By | {row.follow_count}
                                                        </span>
                                                    ) : (

                                                        <span className="followqa followme left R13_9e" onClick={() => this.handleFollow(1, row.queid_ency, row.question_title, row.creater_id) } >
                                                        + Follow | {row.follow_count}
                                                        </span>
                                                    )}

                                                    </span>
                                                </div>

                                                {/* Answer Block */}
                                                <div className="answer-block">
                                                    {row.answer_count > 0 && row.answers?.map((ans) => (
                                                        <div key={ans.answer_id}>
                                                            {/* Answer Top */}
                                                            <div className="ans_top">

                                                                <div className="user_img lft">
                                                                    <img src={ans.ans_userpic || "https://cdn.cdnparenting.com/brainbees/community/Images_folder/father_profile.png"}
                                                                    alt={ans.ans_user_name}
                                                                    />
                                                                    {ans.ans_is_specialist && (
                                                                        <span className="experts-tag listing-expert-tag">
                                                                            Expert
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <div className="mommy">
                                                                    <span className="name M14_42">
                                                                        {ans.ans_user_name}
                                                                    </span>
                                                                    <p className="mom R13_9e">
                                                                        {ans.ans_user_description}
                                                                    </p>
                                                                </div>
                                                                <div className="tm_ago rt R13_9e">
                                                                    {ans.ans_posted_time}
                                                                </div>
                                                            </div>
                                                            {/* Answer Content */}
                                                            <div className="mom_answer R14_61">
                                                                <span className="QA_txt R14_9e">A.</span>
                                                                {this.state.isDesktop ? (
                                                                    <p className="myans">
                                                                        {this.state.expandedAnswers[ans.answer_id] ? ans.answer_details : ans.answer_details.slice(0, 180)}
                                                                        {!this.state.expandedAnswers[ans.answer_id] && ans.answer_details?.length > 180 ? "..." : ""}
                                                                    </p>
                                                                ):(
                                                                    <p className="myans">
                                                                        {this.state.expandedAnswers[ans.answer_id] ? ans.answer_details : ans.answer_details.slice(0, 90)}
                                                                        {!this.state.expandedAnswers[ans.answer_id] && ans.answer_details?.length > 90 ? "..." : ""}
                                                                    </p>
                                                                )}
                                                                {ans.answer_details?.length > (this.state.isDesktop ? 180 : 90) && (
                                                                    <div className="read_more_link">
                                                                        <a className="readmorelink R14_link" 
                                                                            onClick={() => this.toggleAnswerReadMore(ans.answer_id)}
                                                                        > 
                                                                        {this.state.expandedAnswers[ans.answer_id]? "Read Less" : "Read More" }
                                                                        </a>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Like Section */}
                                                            <div className="like-ans like R13_9e">
                                                                <div data-icon-font="&#xe020;" 
                                                                    className={`icon ${ 
                                                                            Array.isArray(this.state.answerLike) && 
                                                                            this.state.answerLike.includes(ans.answer_id) 
                                                                            ? "active-like" : "" 
                                                                        }`
                                                                    }
                                                                    onClick={() => {
                                                                        if (!this.state.answerLike?.includes(ans.answer_id)) {
                                                                            this.handleLike(ans.answer_id, row.queid_ency);
                                                                        }
                                                                    }}
                                                                >
                                                                </div>

                                                                {ans.ans_like_count > 0 && (
                                                                    <span className={`like-count ${ans.ans_like_count} `}>
                                                                        {ans.ans_like_count} Likes
                                                                    </span>
                                                                )} 
                                                            </div>
                                                        
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                        )
                                    })}

                                    {/* Load More Button */}
                                    {/* {this.state.showLoadMore && ( */}
                                    {this.state.expertActionData.my_answer_count > 10 && 
                                    <div id="loadBtn-container">
                                        <div className="desktop-btn load_more askB_1" 
                                            onClick={() => this.loadMoreQues(this.state.expert?.user_id)}
                                        >
                                            <span className="M14_white">LOAD MORE</span>
                                        </div>
                                    </div>
                                    } 
                                </div>
                                }
                            
                                <AnswerOverlay eleRef={this} /> 
                                {this.state.showFollowers && 
                                    <div className="followers-overlay followers-overlay-expert">
                                        <div className="followers-popup">
                                            <div className="like-header">
                                                <span className="M18_48 followers-title">FOLLOWERS</span>
                                                <span className="closeButton icon" onClick={(e)=>this.closePopup(e)} data-icon-font="C" ></span>
                                            </div>
                                            {/* <div className="like-list">
                                            </div> */}


                                            <div className="like-list" 
                                                ref={(el) => (this.listRef = el)} 
                                                onScroll={this.handleScroll}>
                                                <ul>
                                                    {this.state.followersData.map((value) => {

                                                        const mycid = this.state.auth_Data?.token?.mycid; // ✅ FIX

                                                        let defaultImg = "";
                                                        if (value.gender === "female") {
                                                            defaultImg = `https://cdn.cdnparenting.com/brainbees/community/Images_folder/mother_profile.png`;
                                                        } else if (value.gender === "male") {
                                                            defaultImg = `https://cdn.cdnparenting.com/brainbees/community/Images_folder/father_profile.png`;
                                                        } else {
                                                            defaultImg = `https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png`;
                                                        }

                                                        const userName = value.userName?.trim() || "Community User";

                                                        const userDesc =
                                                            value.userDescription || value.userProfileDesc || "";

                                                        const isFollowing =
                                                            this.state.headerData?.getUserActions?.follow_my_user?.includes(value.userId);

                                                        return (
                                                            <li key={value.userId}>
                                                                <div className="answers-block">

                                                                    <div className="userClick" onClick={() => this.handleUserClick(value.userId)} />

                                                                    <div className="experts-details expert_follow_block">

                                                                        {/* Image */}
                                                                        <a className="experts_photo_blocks" href={`/user-profile/${value.userId}`}>
                                                                            <span className="experts-photo">
                                                                                <img
                                                                                    className="imgcheck"
                                                                                    src={value.userPhoto || defaultImg}
                                                                                    onError={(e) => (e.target.src = defaultImg)}
                                                                                    alt={userName}
                                                                                />
                                                                            </span>
                                                                        </a>

                                                                        {/* Name + Description */}
                                                                        <a className="experts_name_blocks" href={`/user-profile/${value.userId}`}>
                                                                            <span className="experts-name">
                                                                                <span className="exp-name M14_42">
                                                                                    {userName}
                                                                                </span>
                                                                                <span className="R13_9e experts-desc">
                                                                                    {userDesc}
                                                                                </span>
                                                                            </span>
                                                                        </a>

                                                                        {/* Follow Button */}
                                                                        {value.userId !== mycid && (
                                                                            <div className="follow-block R13_9e">

                                                                                {this.state.follow_my_user.includes(value.userId) ? (
                                                                                    <span
                                                                                        className="likelist-unfollow"
                                                                                        onClick={(e) => this.handleExpertFollow(value.userId,e,0)}
                                                                                    >
                                                                                        Following
                                                                                    </span>
                                                                                ) : (
                                                                                    <span
                                                                                        className="likelist-follow"
                                                                                        onClick={(e) => this.handleExpertFollow(value.userId,e,1)}
                                                                                    >
                                                                                        Follow
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />

            </main>
        );
    }


}

export default withLocation (ExpertDetail);